<template>
  <div class="calc">
    <div class="home" v-if="currentPage == 'home'">
      <!-- <p>{{activeTab}}</p> -->
      <h1>
        Use this tool to determine which <br />Bausch + Lomb multifocal lenses
        to try first.
      </h1>
      <b-tabs content-class="mt-3" v-model="activeTab">
        <b-tab id="tab-1" title="MULTIFOCAL" active @click="onReset">
          <form>
            <div class="field">
              <p>
                <em><strong><sup>*</sup>Indicates a required field.</strong></em>
              </p>
            </div>
            <p>
              Update spectacle refraction and ADD power, and then select the
              patient’s prescription (adjust for vertex, if necessary).
            </p>
            <br />
            <!-- MOBILE SELECTION -->
            <div class="flex-container mobile-only">
              <!-- <div class="flex-header"><strong>LEFT EYE (OS)</strong></div> -->
              <div class="row-container">
                <div>
                  <strong>
                    <sup>*</sup>
                    <span class="cat">SPHERICAL EQUIVALENT RIGHT EYE (OS): </span>
                  </strong>
                </div>
                <div class="select">
                  <select
                    id="re-sphere-sb"
                    v-model="form.righteye.sphere"
                  >
                    <!-- <option value="">-Select Sphere-</option> -->
                    <option
                      v-for="(val, index) in t1_sphereOptions"
                      :value="val"
                      :key="index"
                      :id="'re-sphere-' + index"
                    >
                      {{ formatValue(val) }}
                    </option>
                  </select>
                </div>
              </div>
              <!-- <br /> -->
              <div class="row-container">
                <div>
                  <strong><sup>*</sup>SPHERICAL EQUIVALENT LEFT EYE (OD):</strong>
                </div>
                <div class="select">
                  <select
                    id="le-sphere-sb"
                    v-model="form.lefteye.sphere"
                  >
                    <!-- <option value="">-Select Sphere-</option> -->
                    <option
                      v-for="(val, index) in t1_sphereOptions"
                      :value="val"
                      :key="index"
                      :id="'le-sphere-' + index"
                    >
                      {{ formatValue(val) }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="row-container">
                <div>
                  <strong><sup>*</sup>ADD OU:</strong>
                </div>
                <div class="select">
                  <select
                    id="re-add-sb"
                    v-model="form.add"
                    @change="onSelect"
                  >
                    <!-- <option value="">-Select ADD-</option> -->
                    <option
                      v-for="(val, index) in addDropdownOptions"
                      :value="val"
                      :key="index"
                      :id="'re-add-' + index"
                    >
                      {{ formatValue(val) }}
                    </option>
                  </select>
                </div>
              </div>
              <br />
              <b-button
                pill
                variant="outline-secondary"
                @click="onSubmit()"
              >
                SEE RESULTS
              </b-button>
            </div>

            <!-- DESKTOP -->
            <div class="field desktop-only">
              <div class="control">
                <b-container class="bv-example-row">
                  <b-row>
                    <b-col></b-col>
                    <b-col>
                      <strong>RIGHT EYE (OS)</strong>
                    </b-col>
                    <b-col>
                      <strong>LEFT EYE (OD)</strong>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <strong>
                        <sup>*</sup>
                          <span class="cat">SPHERICAL EQUIVALENT:</span>
                        </strong>
                    </b-col>
                    <b-col>
                      <div class="select">
                        <select
                          id="re-sphere-sb"
                          v-model="form.righteye.sphere"
                        >
                          <option
                            v-for="(val, index) in t1_sphereOptions"
                            :value="val"
                            :key="index"
                            :id="'re-sphere-' + index"
                          >
                            {{ formatValue(val) }}
                          </option>
                        </select>
                      </div>
                    </b-col>
                    <b-col>
                      <div class="select">
                        <select
                          id="le-sphere-sb"
                          v-model="form.lefteye.sphere"
                        >
                          <option
                            v-for="(val, index) in t1_sphereOptions"
                            :value="val"
                            :key="index"
                            :id="'le-sphere-' + index"
                          >
                            {{ formatValue(val) }}
                          </option>
                        </select>
                      </div>
                    </b-col>
                  </b-row>
                  <hr>
                  <b-row>
                    <b-col>
                      <strong><sup>*</sup>ADD OU:</strong>
                    </b-col>
                    <b-col>
                      <div class="select">
                        <select
                          id="le-add-sb"
                          v-model="form.add"
                          @change="onSelect"
                        >

                          <option
                            v-for="(val, index) in addDropdownOptions"
                            :value="val"
                            :key="index"
                            :id="'le-add-' + index"
                          >
                            {{ formatValue(val) }}
                          </option>
                        </select>
                      </div>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <br />
                      <b-button
                        pill
                        variant="outline-secondary"
                        @click="onSubmit()"
                      >
                        SEE RESULTS
                      </b-button>
                    </b-col>
                  </b-row>
                </b-container>
              </div>
            </div>
          </form>
          <br />
          <br />
          <br />
          <br />
        </b-tab>
        
      </b-tabs>
    </div>
    <div class="results" v-else>
      <h1>Results</h1>
      <br />
      <p v-if="activeTab == 0">
        Prescribe <strong>ULTRA<sup>®</sup> ONEDAY Multifocal, ULTRA<sup>®</sup> for Presbyopia<span v-if="lookForBTOP()">, or Biotrue<sup>®</sup> ONEday for Presbyopia</span></strong> using the following guidance:
      </p>
      <p v-if="activeTab == 1">Prescribe <strong>ULTRA<sup>®</sup> Multifocal for Astigmatism</strong> using the following guidance:</p>
      <br />
      <h4 v-if="form.righteye.sphere !== '' && this.activeTab == 0">
        <strong>
             RIGHT EYE: {{ applyFormula(form.righteye.sphere) }} &nbsp; <br/> ADD: {{ this.addStatus }}
        </strong>
      </h4>
     <h4 v-if="form.lefteye.sphere !== '' && this.activeTab == 0">
        <strong>
          LEFT EYE: {{ applyFormula(form.lefteye.sphere) }} &nbsp;<br/> ADD: {{ this.addStatus }}
        </strong>
      </h4> 
     
     
      <br />

      <StaticChart :highADDRow="multifocalHighADD" :lowADDRow="multifocalLowADD" />

      <b-button pill variant="outline-secondary" @click="onReset">
        ENTER NEW PRESCRIPTION
      </b-button>
    </div>
  </div>
</template>

<script>
import StaticChart from "../components/StaticChart.vue";
export default {
  name: "Calc",
  components: {
    StaticChart,
  },
  props: {},
  methods: {
    lookForBTOP: function() {
      // console.log('IN LOOKFORBTOP FUNC...')
      let adjLS =  this.applyFormula(this.form.lefteye.sphere)
      let adjRS =  this.applyFormula(this.form.righteye.sphere)
      let result;
     
     if (adjRS > -9 && adjLS > -9){
        if (adjRS < 9 && adjLS < 9){
          // console.log('TRUE')
          result = true;
        }else{
          // console.log('FALSE')
          result = false
        }
      } else {
        // console.log('FALSE')
        result = false
      }
    return result;
    },
    applyFormula: function (value){
      // console.log('IN APPLYFORMULA FUNC! ', value);
      let appliedvalue;
      appliedvalue = (Math.round(value * 4) / 4).toFixed(2);
      return appliedvalue;
    },
    formatValue: function (value) {
      // console.log('VALUE ---> ',value)
      return parseFloat(value).toFixed(2);
    },

    formatValueToric: function (value) {
      //console.log('VALUE ---> ',value)
      //console.log(value + ' -- USED ON TORIC CALCULATOR ONLY')
        switch (value) {
          case -1.0:
          value = -0.75
          break;
          case -0.75:
            value
          break;
           case -1.25:
           case -1.5:
            value = -1.25
           break;
           case -1.75:
           case -2.00:
           value = -1.75
           break;
           case -2.25:
           case -2.50:
           case -2.75:
           case -3.00:
            value = -2.25
           break;
          default: 
           value = -2.25
          break;
        }
        return value
  /*    if (value < (-2.00)) {
         let num = -2.25
        return num
      } else {
        return (parseFloat(value).toFixed(2)) - .25;
      }

      */
    },
    formatToricAxis: function (value) {
     // console.log(value +' FORMAT TORIC AXIS')
       let toricNum
      if (value>=5) {
          let roundDownNum = Math.round(value / 10) * 10;
          return roundDownNum;
         
        } else {
          toricNum = value;

          if(value <= 4) {
            let roundDownNumLow = Math.round(value / 10) * 10;
            return roundDownNumLow;
          } else {
            return toricNum;
          }
          

        }

  

   /*   if (value<=4) {
          let roundDownNum = Math.round(value / 10) * 10;
          //console.log(roundDownNum + 'round down Number');
          return roundDownNum;
      } else if (value == 0) {
        //console.log( value + 'DO NOTHING WITH THIS AXIS VALUE')
        return value;
      }  else if (value<=15){
        let roundDownNum = Math.round(value / 10) * 10;
          //console.log(roundDownNum + 'round down Number');
          return roundDownNum;
      }else  {
        let roundUpNum = Math.ceil(value / 10) * 10;
        //console.log( roundUpNum + 'round Up Number')
        return roundUpNum;
      }*/
    },
    onSelect: function () {
      // console.log('ON SELECT ----> ', this.activeTab)
      if (this.form.add >= 1.75 ) {
        this.addStatus = "HIGH";
      
      } else {
        this.addStatus = "LOW";
       
      }

      if (this.form.lefteye.add >= 1.75) {
      /*  this.form.lefteye.addStatus = "HIGH";
        this.form.righteye.addStatus = "HIGH";*/
        this.multifocalHighADD = true;
        this.multifocalLowADD = false;
      
      } else {
        this.form.lefteye.addStatus = "LOW";
        this.form.righteye.addStatus = "LOW";
        this.multifocalHighADD = false;
        this.multifocalLowADD = true;
      }

      if(this.form.lefteye.add >= 1.75 || this.form.righteye.add >= 1.75) {
        this.multifocalHighADD = true;
        this.multifocalLowADD = false;
      }else {
        this.multifocalHighADD = false;
        this.multifocalLowADD = true;
      }

      if (this.form.righteye.add >= 1.75) {
        this.form.righteye.addStatus = "HIGH";
        this.form.lefteye.addStatus = "HIGH";
      } else {
        this.form.righteye.addStatus = "LOW";
        this.form.lefteye.addStatus = "LOW";
      }
    },
    onReset: function (from) {
      if (from !== "radio-btn") {
        this.form.dominantEye = null;
      }
      this.form.add = "0";
      this.currentPage = "home";
      this.form.lefteye.sphere = "0";
      this.form.lefteye.add = "0";
      this.form.lefteye.cylinder = "-3.25";
      this.form.lefteye.axis = "90";
      this.form.righteye.sphere = "0";
      this.form.righteye.add = "0";
      this.form.righteye.cylinder = "-3.25";
      this.form.righteye.axis = "90";
      this.addStatus = "LOW";
      this.form.righteye.addStatus = "LOW";
      this.form.lefteye.addStatus = "LOW";
      this.multifocalHighADD = false;
      this.multifocalLowADD = false;
    },
    onSubmit: function () {
      console.log("OUCH! ---> Submit clicked ----> Active Tab: ", this.activeTab);
      console.log('MF ADD ----- ' + this.form.add )
      this.currentPage = "results";

     if ( this.activeTab == 0) {

           if (this.form.add >= 1.75 ) {

              this.multifocalHighADD = true;
              this.multifocalLowADD = false;
            
              } else {
              this.multifocalHighADD = false;
              this.multifocalLowADD = true;
          
              }

      } else  {

        if (this.form.lefteye.add >= 1.75 || this.form.righteye.add >= 1.75 ) {
     
          this.multifocalHighADD = true;
          this.multifocalLowADD = false;
          this.form.righteye.addStatus = "HIGH";
          this.form.lefteye.addStatus = "HIGH";

        } else {
          this.multifocalHighADD = false;
          this.multifocalLowADD = true;
          this.form.righteye.addStatus = "LOW";
          this.form.lefteye.addStatus = "LOW";

        
        }

      }
    
    },
  },
  data() {
    return {
      t1_sphereOptions: [
        -10.00, -9.75, -9.5, -9.25, 
        -9.0, -8.75, -8.5, -8.25, 
        -8.0, -7.75, -7.5, -7.25,
        -7.0, -6.75, -6.5, -6.25, 
        -6.0, -5.75, -5.5, -5.25, 
        -5.0, -4.75, -4.5, -4.25, 
        -4.0, -3.75, -3.5, -3.25, 
        -3.0, -2.75, -2.5, -2.25, 
        -2.0, -1.75, -1.5, -1.25, 
        -1.0, -0.75, -0.5, -0.25, 
        0.0, 0.25, 0.5, 0.75, 
        1.0, 1.25, 1.5, 1.75, 
        2.0, 2.25, 2.5, 2.75, 
        3.0, 3.25, 3.5, 3.75, 
        4.0, 4.25, 4.5, 4.75, 
        5.0, 5.25, 5.5, 5.75, 
        6.0, 6.25, 6.5, 6.75, 
        7.0, 7.25, 7.5, 7.75, 
        8.0, 8.25, 8.5, 8.75, 
        9.0, 9.25, 9.5, 9.75, 
        10.0,
      ],
      t2_sphereOptions: [
        -6.0, -5.75, -5.5, -5.25, 
        -5.0, -4.75, -4.5, -4.25, 
        -4.0, -3.75, -3.5, -3.25, 
        -3.0, -2.75, -2.5, -2.25, 
        -2.0, -1.75, -1.5, -1.25, 
        -1.0, -0.75, -0.5, -0.25, 
        0.0, 0.25, 0.5, 0.75, 
        1.0, 1.25, 1.5, 1.75, 
        2.0, 2.25, 2.5, 2.75, 
        3.0, 3.25, 3.5, 3.75, 
        4.0],
      addDropdownOptions: [0.0, 0.75, 1.0, 1.25, 1.5, 1.75, 2.0, 2.25, 2.5],
      //cylinderOptions: [-0.75, -0.5, -0.25, 0.0, 0.25, 0.5, 0.75, 1.0, 1.25, 1.5, 1.75, 2.0, 2.25, 2.5, 2.75, 3.0, 3.25],
      cylinderOptions: [-3.25,-3.00, -2.75, -2.50, -2.25, -2.00, -1.75, -1.50, -1.25, -1.00,-.75],
      axisOptions: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126, 127, 128, 129, 130, 131, 132, 133, 134, 135, 136, 137, 138, 139, 140, 141, 142, 143, 144, 145, 146, 147, 148, 149, 150, 151, 152, 153, 154, 155, 156, 157, 158, 159, 160, 161, 162, 163, 164, 165, 166, 167, 168, 169, 170, 171, 172, 173, 174, 175, 176, 177, 178, 179, 180],
      form: {
        add: 0,
        lefteye: {
          sphere: "0",
          cylinder: "-3.25",
          axis: "90",
          add: "0",
          addStatus: "LOW",
        },
        righteye: {
          sphere: "0",
          cylinder: "-3.25",
          axis: "90",
          add: "0",
          addStatus: "LOW",
        },
      },
      errors: [],
      currentPage: "home",
      addStatus: "LOW",
      activeTab: 0,
      multifocalHighADD: null,
      multifocalLowADD: null,
    };
  },
  computed: {},
  watch: {
    multifocalHighADD: function (bool) {
      this.multifocalHighADD = bool;
      console.log('WATCHER HIGH ------ ' + this.multifocalHighADD);
    },
    multifocalLowADD: function (bool) {
      this.multifocalLowADD = bool;
      console.log('WATCHER LOW ------ ' + this.multifocalLowADD);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.results {
  text-align: left;
}
.results .bordered {
  /*border: 1px solid #000;*/
  border-top: 1px solid #000;
  border-left: 1px solid #000;
  border-right: 1px solid #000;
}
.results .bordered:nth-of-type(odd) {
  border-bottom: 1px solid #000;
}
.results .bordered td {
  border-right: 1px solid #000;
}
.results .bordered .col:last-of-type {
  border-right: none;
}
table {
  width: 100%;
}
table th {
  width: 33%;
}
table td {
  padding: 20px;
  text-align: center;
}
table th:not(:first-of-type) {
  text-align: center;
}
.col {
  flex: unset;
}

.flex-container {
  display: flex;
  flex-direction: column;
}
.desktop-only {
  display: none;
}
.center-left-title-toric-tile-mobile {
  padding-right: 0;
}
@media only screen and (min-width: 601px) {
  .col {
    flex: 1 0 0%;
  }

  .flex-container {
    border: 1px solid blue;
    flex-direction: row;
  }
  .row-container {
    display: block;
    width: 75%;
    float: left;
  }
  .row-container div {
    display: inline-block;
    width: 33%;
  }
  .mobile-only {
    display: none;
  }
  .desktop-only {
    display: block;
  }
  .toric-calc-results {
    display: inline-flex; 
    flex-wrap: wrap;
  }

  .toric-calc-results  .left-column {
        margin-right: 0;
    }
  @media screen and (min-width: 1025px) {
    .toric-calc-results  .left-column {
        margin-right:  1.3vw;
    }
  }
}
</style>
